/**
 * Stable per-install device identifier persisted in `localStorage`.
 *
 * Mirror dos `KeychainDeviceIdentifierStore` (iOS) e
 * `EncryptedPreferencesDeviceIdentifierStore` (Android), com a mesma
 * semântica do `fields-system-web-react`: gera UUID na primeira leitura e
 * reusa daí em diante. O backend de push usa essa string como chave
 * natural (`device_identifier`) — sobrevive token rotation, refresh, e
 * trocas de user no mesmo browser/install.
 *
 * `localStorage` é o storage certo: persiste entre reloads e restarts,
 * só some quando o usuário limpa site data (equivalente a desinstalar o
 * app). Não é segredo — não precisa de cripto no client.
 */

const STORAGE_KEY = 'meiuca-app-web.push.deviceIdentifier';

export function getOrCreatePushDeviceId(): string {
  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing) return existing;
  const fresh = generateUuid();
  localStorage.setItem(STORAGE_KEY, fresh);
  return fresh;
}

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}
